import { FC, PropsWithChildren } from 'react';
import { HTMLButtonType } from 'helpers';

type ButtonProps = FC<
    PropsWithChildren<{
        disabled?: boolean;
        onClick?: () => any;
        type?: HTMLButtonType;
        className: string;
    }>
>;

const Button: ButtonProps = ({ children, onClick, className, type, disabled }) => {
    return (
        <button type={type} className={className} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default Button;
